import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselIndicators,
  CarouselPrevious,
  CarouselNext,
} from '@/components/ui/carousel';
import { cn } from '@/lib/utils';
import type { BlogPageDataResponse } from '@/services/cms/getBlogContent/schemas';
import { BlogCard } from '@/components/blog/blog-card';
interface CMSColumnsCarouselProps {
  className?: string;
  data: BlogPageDataResponse[];
}
const BlogDetailedCarousel = ({ className, data }: CMSColumnsCarouselProps) => {
  const itemsCount = data.length;
  return (
    <Carousel
      opts={{
        align: 'center',
        breakpoints: {
          '(min-width: 768px)': {
            // 'md' => Tablet breakpoint
            slidesToScroll: 2,
            active: itemsCount > 2,
          },
          '(min-width: 1280px)': {
            // 'lg' => Desktop breakpoint
            slidesToScroll: 3,
            active: itemsCount > 4,
          },
        },
      }}
      className={cn(
        'w-full pl-5 py-6 md:py-12 lg:py-16 container md:container',
        className
      )}
    >
      <CarouselContent
        className={cn('-ml-3 md:-ml-8 lg:-ml-6', {
          'lg:justify-center': itemsCount <= 2,
        })}
      >
        {data.map((item, index) => (
          <CarouselItem
            key={index}
            className={cn(
              'md:basis-1/2 lg:basis-1/4 select-none pl-3 md:pl-8',
              {
                // Show partial next slide only if there's more than one item
                'basis-[100%]': itemsCount > 1,
                'basis-full': itemsCount === 1,
                'lg:basis-[384px] lg:pl-6': itemsCount >= 3,
              }
            )}
          >
            {<BlogCard className="h-full" blogCardData={item} />}
          </CarouselItem>
        ))}
      </CarouselContent>
      <div
        className={cn(
          'hidden',
          // Even if show_nav_arrows is true, we need to display the arrows just if it's necessary
          itemsCount > 2 ? 'md:block' : 'md:hidden',
          itemsCount >= 4 ? 'lg:block' : 'lg:hidden'
        )}
      >
        <CarouselPrevious
          className={cn(
            'text-deep-teal-500 md:left-7 lg:left-[9.5rem] lg:bottom-11'
          )}
        />
        <CarouselNext
          className={cn(
            'text-deep-teal-500 md:right-7 lg:right-[10rem] lg:bottom-11'
          )}
        />
      </div>
      <CarouselIndicators
        className={cn(
          'mt-6 md:mt-8 lg:mt-20 [&_[data-active=true]]:text-deep-teal-500 [&_[data-active=false]]:text-grey-200',
          {
            'md:hidden': itemsCount <= 2,
            'lg:hidden': itemsCount <= 3,
          }
        )}
      />
    </Carousel>
  );
};
export { BlogDetailedCarousel };
